import React from "react";
import SummaryPie from "./SummaryPie";
import TradePie from "./TradePie";

const SurveySummary = () => {
  return (
    <div className="w-full font-manrope flex justify-center items-start gap-6">
      <div className="w-1/2 bg-[#1C2227] px-5 py-12">
        <h4 className="text-white font-bold text-[16px]">
          What is your primary use of DeeX app?
        </h4>
        <div className="w-full mt-8">
          <SummaryPie />
        </div>
      </div>
      <div className="w-1/2 bg-[#1C2227] px-5 py-12">
        <h4 className="text-white font-bold text-[16px]">
          How much volume do you trade monthly?
        </h4>
        <div className="w-full mt-8">
          <TradePie />
        </div>
      </div>
    </div>
  );
};

export default SurveySummary;
